import React, { useState } from 'react';

import Modal from '../../../components/Modal';

import { SplashModalProps } from '../types';

import {
  ModalContainer,
  SplashImage,
  DismissContainer,
  DismissCheckbox,
  DismissLabel,
} from '../styles';

const SplashModal: React.FC<SplashModalProps> = ({
  open,
  imageUrl,
  onClose,
  onDismiss,
}) => {
  const [dismissed, setDismissed] = useState(false);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.checked || dismissed) return;
    setDismissed(true);
    await onDismiss();
  };

  return (
    <Modal
      centered
      visible={open}
      onCancel={onClose}
      width={800}
      variant="splash"
    >
      <ModalContainer>
        <SplashImage
          src={imageUrl}
          alt="Splash"
        />
        <DismissContainer>
          <DismissCheckbox
            type="checkbox"
            id="splash-dismiss"
            checked={dismissed}
            disabled={dismissed}
            onChange={handleChange}
          />
          <DismissLabel htmlFor="splash-dismiss">
            Não mostrar novamente
          </DismissLabel>
        </DismissContainer>
      </ModalContainer>
    </Modal>
  );
};

export default SplashModal;